import { IconProps } from "./IconProps";

export const InsuranceIcon = (props: IconProps) => {
  return (
    <svg
      width="20"
      height="20"
      className={props.className}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6667 10.4167V5.66666C16.6667 4.26653 16.6667 3.56646 16.3942 3.03168C16.1545 2.56128 15.772 2.17882 15.3016 1.93914C14.7669 1.66666 14.0668 1.66666 12.6667 1.66666H7.33333C5.9332 1.66666 5.23313 1.66666 4.69835 1.93914C4.22795 2.17882 3.8455 2.56128 3.60581 3.03168C3.33333 3.56646 3.33333 4.26653 3.33333 5.66666V14.3333C3.33333 15.7335 3.33333 16.4335 3.60581 16.9683C3.8455 17.4387 4.22795 17.8212 4.69835 18.0608C5.23313 18.3333 5.9332 18.3333 7.33333 18.3333H10M11.6667 9.16666H6.66666M8.33333 12.5H6.66666M13.3333 5.83332H6.66666M12.0833 15.8333L13.75 17.5L17.5 13.75"
        stroke="#06123D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
